const validator = {
    getMessage(field, args) {
        return `Seu CEP não é válido para este plano`
    },
    validate(value, args) {
        console.log(args)
        return value.startsWith(args[0])
    }
}

export default validator